import { createAppStore } from '@saniplus/api-client';

/**
 * One store per app, built by the shared factory so the base slice, the auth
 * slice and the RTK Query middleware are wired identically in both.
 *
 * Feature slices (list filters, calendar view, the punch-queue mirror) are
 * added through the `reducers` option — never by calling `configureStore`
 * again here.
 */
export const store = createAppStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
